import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTreeChristmas = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tree-christmas" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.933,20a.749.749,0,0,0,.592-1.21l-4.308-5.54h1.5a.751.751,0,0,0,.6-1.2l-3.6-4.8h1.6a.75.75,0,0,0,.624-1.166l-3.1-4.648a.751.751,0,0,0-1.249,0l-3.1,4.648A.75.75,0,0,0,9.118,7.25h1.6l-3.6,4.8a.75.75,0,0,0,.6,1.2h1.5L4.908,18.79A.749.749,0,0,0,5.5,20Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 12.217,
			y1: 20,
			x2: 12.217,
			y2: 23
		})
	]
});
export default SvgTreeChristmas;
